import React, { useMemo } from 'react'
import _, { isEqual } from 'lodash'
import { FieldSet } from '@sencha/ext-modern'

import { changeListItem, getListFromValues } from '../../../utility'
import { genFullListName, getMixedProps } from './blockPublic'
import TyanGrid from './TyanGrid'
import { useDelayTimer, useEventHandler, useInstData } from 'tyan/public/hooks'

const MyGrid = (props) => {
	const { config: { that, /* onChange,  */initValues, changedValues, defaultStyle,
		field: {
			ignore, _fieldsetName: fieldsetName, label, name: listNamePar, list: listConf, data: dataProp, onSelect: onSelectPar, value, ...field
		}
	} } = props

	const listName = genFullListName(listConf, listNamePar)
	const { me, me: { gridID } } = useInstData(props, useMemo(() => ({ gridID: `_grid-${Tyan.getUuid()}`, selected: [] }), []))
	const { props: { height, ...pnlProps } } = getMixedProps('_grid', [defaultStyle, field])
	!label && !field.padding && (pnlProps.padding = '5px 0px 5px 0px')

	let { list } = getListFromValues(listName, value, initValues, changedValues, ignore)
	// console.log('grid list:', list)
	list = dataProp || list
	list = me.list = _.isEqual(me.list, list) ? me.list : list
	// const { height } = field
	// console.log('list:', list, ignore)
	const compHeightProps = {}
	height && height !== '100%' && (compHeightProps.height = height)

	const { doDelay: delayEdit } = useDelayTimer(150)

	const editParams = {
		changedValues: [],
		typesOfChangedValues: {},
		ids: []
	}

	const handleEdit = useEventHandler(({ id, name, newValue, oldValue, data, record, type, changedValues, typesOfChangedValues }) => {
		let index = editParams.ids.indexOf(id)
		let changedValue = {}
		if (index < 0) {
			editParams.ids.push(id)
			editParams.changedValues.push({})
			index = editParams.ids.length - 1
		}

		// console.log('handleEdit:', id, name, newValue, oldValue, type, changedValues, typesOfChangedValues)

		editParams.changedValues[index] = { ...editParams.changedValues[index], ...(changedValues ? changedValues : { [name]: newValue }) }
		editParams.typesOfChangedValues = { ...editParams.typesOfChangedValues, ...(changedValues ? typesOfChangedValues : type ? { [name]: type } : {}) }

		delayEdit(() => {
			// console.log('delayEdit', editParams)
			changeListItem(that,
				editParams.changedValues, // changedValues ? changedValues : { [name]: newValue },
				editParams.typesOfChangedValues, // changedValues ? typesOfChangedValues : type ? { [name]: type } : undefined,
				fieldsetName, listName,
				editParams.ids	// id
			)

			editParams.changedValues = []
			editParams.typesOfChangedValues = {}
			editParams.ids = []
		})
	})

	const handleBatchEdit = useEventHandler(
		(changedValues, typesOfChangedValues) => {
			const ids = list.map(({ id }) => id)
			// const typesOfChangedValues = Object.entries(changedValues).reduce((sum, { name, value }) => (sum[name] = typeof value), {})

			// console.log('batchEdit:',
			// 	Array(ids.length).fill(changedValues),
			// 	typesOfChangedValues || {},
			// 	fieldsetName, listName,
			// 	ids
			// )

			ids.length && changeListItem(that,
				Array(ids.length).fill(changedValues),
				typesOfChangedValues || {},
				fieldsetName, listName,
				ids
			)
		}
	)

	const myProps = {
		list, that, gridID,
		onSelect: (s) => {
			if (isEqual(s, me.selected))
				return
			me.selected = s
			onSelectPar && onSelectPar(s)
			if (!onSelectPar) {
				const selectedValues = { [`${listName}`]: s }
				that.setState(state => { return { [`_gridSelectedValues${fieldsetName}`]: { ...state[`_gridSelectedValues${fieldsetName}`], ...selectedValues } } })
			}
		},
		handleEdit,
		handleBatchEdit,
		...field,
		height
	}

	return <FieldSet id={`fieldset-${gridID}`} title={label} {...pnlProps} layout='fit' {...compHeightProps} errorTarget={undefined}>
		<TyanGrid {...myProps} />
	</FieldSet>
}

const renderGrid = config => {
	const { key } = config.field || {}
	return <MyGrid key={key} config={config} />
}

export default renderGrid